import { get } from 'lodash';
import { getSetting } from '@utils/helpers';
import configFile from './config.json';

const CSV_DOWNLOAD_HARD_LIMIT = 10000;

export const config = {};
// Check for custom logo, if not load default
if (configFile.customer.logo) {
  // if (fs.existsSync(path)) {
  config.logo = configFile.customer.logo;
}

// Load the default route
export const getHomeRoute = () => {
  if (configFile.customer.defaultScreen) {
    config.homeRoute = configFile.customer.defaultScreen;
  } else {
    config.homeRoute = '/home';
  }
  return config.homeRoute;
};

export const getLogo = () => {
  if (configFile.customer.logo) {
    return configFile.customer.logo;
  }
};

export const getLogoLink = () => configFile.customer.logoLink;

export const getLogoLinkCaption = () => configFile.customer.logoLinkCaption;

export const getMenuItems = () => {
  const menu = get(getSetting('menu'), 'menu');
  if (Array.isArray(menu)) {
    return menu;
  }
  if (configFile.customer.sideBar.menu) {
    return configFile.customer.sideBar.menu;
  }
};
export const getCSVDownloadHardLimit = () => {
  return CSV_DOWNLOAD_HARD_LIMIT;
};
export const getCSVDownloadLimit = () => {
  let CSVLimit = CSV_DOWNLOAD_HARD_LIMIT;
  const settingLimit = get(getSetting('CSVDownloadLimit'), 'CSVDownloadLimit');
  if (settingLimit) {
    const parsed = parseInt(settingLimit, 10);
    if (!isNaN(parsed)) {
      CSVLimit = Math.min(parsed, CSVLimit);
    }
  }
  return CSVLimit;
};

export const getTermsOfUseString = () => configFile.customer.termsOfUseString || '';

export const getTermsOfUseLinkCaption = () => configFile.customer.termsOfUseLinkCaption || '';

export const getTermsOfUseLinkUrl = () => configFile.customer.termsOfUseLinkUrl || '';

export const getCopyrightString = () => configFile.customer.copyrightString || '';

export const getEnvironment = () => configFile.customer.environment || '';

export const getApplicationName = () => configFile.customer.applicationName || 'TrackSphere';

export const getAppVersion = () => {
  //Get version from lerna.json
  const packageJson = require('../../package.json');
  return packageJson.version;
};

export default {
  getHomeRoute,
  getLogo,
  getLogoLink,
  getLogoLinkCaption,
  getMenuItems,
  getCSVDownloadHardLimit,
  getCSVDownloadLimit,
  getTermsOfUseString,
  getTermsOfUseLinkCaption,
  getTermsOfUseLinkUrl,
  getCopyrightString,
  getEnvironment,
  getApplicationName,
  getAppVersion,
};
